import classNames from "classnames";
import { createPortal } from "react-dom";
import { ModalProvider } from "./ModalContext";
import { ModalProps } from "./Modal.types";

/** A centred Bootstrap modal over a backdrop, drawn into #modal-root. */
export function Modal({ title, onClose, children, className }: ModalProps) {
  const root = document.getElementById("modal-root") ?? document.body;

  return createPortal(
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal d-block" tabIndex={-1} aria-modal="true">
        <div
          className={classNames("modal-dialog modal-dialog-centered", className)}
          role="document"
        >
          <div className="modal-content">
            {(title || onClose) && (
              <div className="modal-header">
                <h3 className="modal-title">{title}</h3>
                {onClose && (
                  <button
                    type="button"
                    className="btn btn-close float-end"
                    aria-label="Close"
                    onClick={onClose}
                  />
                )}
              </div>
            )}
            <ModalProvider value>{children}</ModalProvider>
          </div>
        </div>
      </div>
    </>,
    root
  );
}

export default Modal;
